<template>
  <div class="job schedule content pull-left">
    <div class="page-header" ng-show="!maximizeTable">
      <h1 v-if="!fullscreen" class="capitalize">Pier Schedule</h1>
    </div>

    <span>
      <b-navbar variant="light">
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <slot name="left"></slot>
            <b-nav-form>
              <b-form-input
                class="mr-2"
                placeholder="Search"
                v-model="list_options.q"
                @keydown.enter="refreshList()"
              ></b-form-input>
              <b-form-select
                v-model="list_options.customer"
                :options="optionsCustomer"
                class="mr-2 mpl-2"
              ></b-form-select>
              <b-form-select
                v-model="list_options.job_location"
                :options="optionsCodeJobLocation"
                class="mr-2 mpl-2"
              ></b-form-select>

              <b-button
                v-b-tooltip
                title="Search"
                @click="refreshList()"
                class="ml-0 my-2"
                ><b-icon icon="search"></b-icon
              ></b-button>

              <o-date-time
                v-model="list_options.wantedPierDateFilter"
                nolabel
                placeholder="Wanted Pour Date"
                name="wanted_pier_date"
                locale="en"
                class="ml-2"
                hide-time
                no-buttons
                @input="refreshList()"
              ></o-date-time>

              <b-button class="ml-2" @click="changewantedPierDateFilter(-3)">
                <b-icon icon="dash"> </b-icon>
              </b-button>

              <b-button class="ml-2" @click="changewantedPierDateFilter(0)">
                <b-icon icon="calendar"> </b-icon>
              </b-button>

              <b-button class="ml-2" @click="changewantedPierDateFilter(3)">
                <b-icon icon="plus"> </b-icon>
              </b-button>

              <b-button
                v-b-tooltip
                title="Clear Search"
                id="clear_search"
                @click="clearFilters()"
                class="ml-2 my-2 my-sm-0"
                variant="danger"
                >Clear</b-button
              >
              <b-button class="ml-2 my-2 my-sm-0" @click="setFullScreen()">
                <b-icon icon="arrows-fullscreen"></b-icon>
              </b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </span>

    <template>
      <div>
        <b-table
          bordered
          :fields="fields"
          :items="items_with_date_breaks"
          head-variant="light"
          class="o-list"
          :tbody-tr-class="row_class"
          thead-class="o-gradient-header"
          :sticky-header="allocation_height"
          :style="{ height: allocation_height, 'font-size': '11pt' }"
          no-local-sorting
          @sort-changed="change_sort"
          :sort-by="list_options.sort"
          :sort-desc="list_options.order === 'desc'"
        >
          <template slot="top-row" slot-scope="{ columns }">
            <!-- slot top-row requires you to provide your own td element(s) -->
            <td :colspan="columns">
              <span class="daterow" v-if="items && items.length > 0">
                <date-display
                  :value="items[0].actual_pier_date"
                  default-value="None"
                  :format="DAY_DATE_FORMAT"
                ></date-display
              ></span>
            </td>
          </template>
          <template #row-details="row">
            <span class="daterow">
              <date-display
                :value="row.item._previous_actual_pier_date"
                default-value="None"
                :format="DAY_DATE_FORMAT"
              ></date-display
            ></span>
          </template>

          <template slot="cell(active_end_date)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'active_end_date'"
            >
              <date-display
                :value="item.active_end_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(active_start_date)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'active_start_date'"
            >
              <date-display
                :value="item.active_start_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(bob_cat)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'bob_cat')"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.bob_cat"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'bob_cat_ohs')"
            >
              <boolean-display
                show-icon
                :value="item.bob_cat_ohs"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'bob_cat_date')"
            >
              <date-display
                :value="item.bob_cat_date"
                :format="DAY_DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(bob_cat_date)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'bob_cat_date')"
            >
              <date-display
                :value="item.bob_cat_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(bob_cat_ohs)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'bob_cat_ohs'"
            >
              <boolean-display
                show-icon
                :value="item.bob_cat_ohs"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(comments)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'comments')"
            >
              <multi-line-display
                :value="item.comments"
                display-line-breaks
                default-value="[Set]"
                default-class="text-red"
              ></multi-line-display>
            </b-link>
          </template>
          <!--template slot="cell(concrete_notes)" slot-scope="{index, item}">
                <b-link class="editable"  v-on:click="showModal(index, item, 'concrete_notes')">
                    <default-display :value="item.concrete_notes"></default-display>                </b-link>
            </template-->
          <template slot="cell(concrete_order)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'concrete_order')"
            >
              <date-display
                :value="item.concrete_order"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'concrete_notes')"
            >
              <default-display :value="item.concrete_notes"></default-display>
            </b-link>
          </template>
          <template slot="cell(created_date)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'created_date'"
            >
              <date-display
                :value="item.created_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(crew_supplier)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'crew_supplier')"
            >
              <lookup-display
                :list="optionCrewItemsById"
                :value="item.crew_supplier"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'plan_provided')"
            >
              <boolean-display
                show-icon
                :value="item.plan_provided"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
          </template>
          <template
            slot="cell(pier_pump_supplier)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_pump_supplier')"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.pier_pump_supplier"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </b-link>
          </template>
          <template slot="cell(crew_leader)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'crew_leader'"
            >
              <lookup-display
                :list="optionEmployeeItemsById"
                :value="item.crew_leader"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(customer)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'customer'"
            >
              <lookup-display
                :list="optionCustomerItemsById"
                :value="item.customer"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(date_call_up_received)"
            slot-scope="{ index, item }"
          >
            <date-display
              :value="item.date_call_up_received"
              :format="DAY_DATE_FORMAT"
            ></date-display>
          </template>
          <template slot="cell(date_sent_to_myob)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'date_sent_to_myob'"
            >
              <date-display
                :value="item.date_sent_to_myob"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(drain_date)" slot-scope="{ index, item }">
            <date-display
              :value="item.drain_date"
              :format="DAY_DATE_FORMAT"
            ></date-display>
          </template>
          <template slot="cell(files)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'files'"
            >
              <default-display :value="item.files"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(inspector)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'inspector'"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.inspector"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(invoices)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'invoices'"
            >
              <p class="m-0" v-for="invoice in item.invoices">
                <date-display
                  :value="invoice['date_invoiced']"
                  :format="DATE_FORMAT"
                  default-value="[Set]"
                  default-class="text-red"
                ></date-display>
              </p>
            </o-link-cell>
          </template>
          <template slot="cell(is_pier_passed)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'is_pier_passed'"
            >
              <boolean-display
                show-icon
                :value="item.is_pier_passed"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(job_location)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'job_location'"
            >
              <lookup-display
                :list="optionCodeJobLocationItemsById"
                :value="item.job_location"
                display-field="description"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(job_type)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'job_type'"
            >
              <lookup-display
                :list="optionCodeJobTypeItemsById"
                :value="item.job_type"
                display-field="description"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(lot_no)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'lot_no'"
            >
              <default-display :value="item.lot_no"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(m2)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'm2'"
            >
              <number-display :value="item.m2" :decimals="2" />
            </o-link-cell>
          </template>
          <template slot="cell(modified_date)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'modified_date'"
            >
              <date-display
                :value="item.modified_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(no_of_piers)" slot-scope="{ index, item }">
            <number-display
              :value="item.no_of_piers"
              :decimals="0"
              default="[Set]"
              default-class="text-red"
            />
          </template>
          <template
            slot="cell(piers_concrete_ordered)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'piers_concrete_ordered')"
            >
              <number-display
                :value="item.piers_concrete_ordered"
                :decimals="1"
                default="[Set]"
                default-class="text-red"
              />
            </b-link>
            <br />
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_concrete_supplier'"
            >
              <b-link
                class="editable"
                v-on:click="showModal(index, item, 'pier_concrete_supplier')"
              >
                <lookup-display
                  :list="optionSupplierItemsById"
                  :value="item.pier_concrete_supplier"
                  display-field="name"
                  default-value="[Set]"
                  default-class="text-red"
                ></lookup-display>
              </b-link>
            </o-link-cell>
            <!-- <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'piers_concrete_ordered'"
            >
              <number-display
                :value="item.piers_concrete_ordered"
                :decimals="0"
              />
            </o-link-cell> -->
          </template>
          <template
            slot="cell(pier_concrete_notes)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_concrete_notes')"
            >
              <default-display
                :value="item.pier_concrete_notes"
                :decimals="0"
                default-value="[Set]"
                default-class="text-red"
              />
            </b-link>
            <!-- <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_concrete_notes'"
            >
              <default-display
                :value="item.pier_concrete_notes"
              ></default-display>
            </o-link-cell> -->
          </template>
          <template
            slot="cell(pier_concrete_supplier)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_concrete_supplier'"
            >
              <b-link
                class="editable"
                v-on:click="showModal(index, item, 'pier_concrete_supplier')"
              >
                <lookup-display
                  :list="optionSupplierItemsById"
                  :value="item.pier_concrete_supplier"
                  display-field="name"
                  default-value="[Set]"
                  default-class="text-red"
                ></lookup-display>
              </b-link>
              <!-- <default-display
                :value="item.pier_concrete_supplier__name"
              ></default-display> -->
              <!-- <lookup-display
                :list="optionSupplierItemsById"
                :value="item.pier_concrete_supplier__name"
                display-field="name"
                default-value="-"
              ></lookup-display> -->
            </o-link-cell>
          </template>
          <template
            slot="cell(pier_poured_by_supplier)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_poured_by_supplier'"
            >
              <b-link
                class="editable"
                v-on:click="showModal(index, item, 'pier_poured_by_supplier')"
              >
                <lookup-display
                  :list="optionSupplierItemsById"
                  :value="item.pier_poured_by_supplier"
                  display-field="name"
                  default-value="[Set]"
                  default-class="text-red"
                ></lookup-display>
              </b-link>
              <!-- <lookup-display
                :list="optionCrewItemsById"
                :value="item.pier_poured_by__name"
                display-field="name"
                default-value="-"
              ></lookup-display> -->
            </o-link-cell>
          </template>
          <template slot="cell(pier_poured_by)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_poured_by'"
            >
              <b-link
                class="editable"
                v-on:click="showModal(index, item, 'pier_poured_by')"
              >
                <lookup-display
                  :list="optionCrewItemsById"
                  :value="item.pier_poured_by"
                  display-field="name"
                  default-value="[Set]"
                  default-class="text-red"
                ></lookup-display>
              </b-link>
              <!-- <lookup-display
                :list="optionCrewItemsById"
                :value="item.pier_poured_by__name"
                display-field="name"
                default-value="-"
              ></lookup-display> -->
            </o-link-cell>
          </template>
          <template
            slot="cell(pier_inspection_approved)"
            slot-scope="{ index, item }"
          >
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_inspection_date')"
            >
              <date-display
                :value="item.pier_inspection_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_inspection_approved')"
            >
              <boolean-display
                show-icon
                :value="item.pier_inspection_approved"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
            <br />
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_concrete_supplier'"
            >
              <b-link
                class="editable"
                v-on:click="showModal(index, item, 'pier_inspector_supplier')"
              >
                <lookup-display
                  :list="optionSupplierItemsById"
                  :value="item.pier_inspector_supplier"
                  display-field="name"
                  default-value="[Set]"
                  default-class="text-red"
                ></lookup-display>
              </b-link>
              <!-- <default-display
                :value="item.pier_concrete_supplier__name"
              ></default-display> -->
              <!-- <lookup-display
                :list="optionSupplierItemsById"
                :value="item.pier_concrete_supplier__name"
                display-field="name"
                default-value="-"
              ></lookup-display> -->
            </o-link-cell>
          </template>
          <template
            slot="cell(pier_concrete_confirmed)"
            slot-scope="{ index, item }"
          >
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_concrete_confirmed')"
            >
              <boolean-display
                show-icon
                :value="item.pier_concrete_confirmed"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
          </template>
          <template
            slot="cell(pier_concrete_time)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_concrete_time')"
            >
              <date-display
                :value="item.pier_concrete_time"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(notes)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'notes'"
            >
              <default-display :value="item.notes"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(ohs)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'ohs'"
            >
              <boolean-display show-icon :value="item.ohs"></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(original_data)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'original_data'"
            >
              {{ item.original_data }}
            </o-link-cell>
          </template>
          <template
            slot="cell(original_job_number)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'actual_pier_date'"
              class="a_blacked"
            >
              <default-display :value="jobNumber(item)"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(part_a_required)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'part_a_required'"
            >
              <boolean-display
                show-icon
                :value="item.part_a_required"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(part_a_supplier)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'part_a_supplier')"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.part_a_supplier"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'termite_part_a_date')"
            >
              <date-display
                :value="item.termite_part_a_date"
                :format="DAY_DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(pier_booking_no)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_booking_no')"
            >
              <default-display
                :value="item.pier_booking_no"
                default-value="[Set]"
                default-class="text-red"
              ></default-display>
            </b-link>
          </template>
          <template slot="cell(pier_date)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_date')"
            >
              <date-display
                :value="item.pier_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(actual_pier_date)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'actual_pier_date')"
            >
              <date-display
                :value="item.actual_pier_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template
            slot="cell(pier_inspection_date)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pier_inspection_date')"
            >
              <date-display
                :value="item.pier_inspection_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(pier_ohs)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pier_ohs'"
            >
              <boolean-display
                show-icon
                :value="item.pier_ohs"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(piers_crew)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'piers_crew'"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.piers_crew"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(plan_provided)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'plan_provided'"
            >
              <boolean-display
                show-icon
                :value="item.plan_provided"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(pod_picked_up_date)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pod_picked_up_date'"
            >
              <date-display
                :value="item.pod_picked_up_date"
                :format="DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(pour_date)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pour_date')"
            >
              <date-display
                :value="item.pour_date"
                default-value="None"
                :format="DAY_DATE_FORMAT"
              ></date-display>
            </b-link>
          </template>
          <template
            slot="cell(pre_slab_booked_date)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pre_slab_booked_date')"
            >
              <date-display
                :value="item.pre_slab_booked_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pre_slab_inspection_passed')"
            >
              <boolean-display
                show-icon
                :value="item.pre_slab_inspection_passed"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pre_slab_booking_no')"
            >
              <default-display
                :value="item.pre_slab_booking_no"
                default-value="[Set]"
                default-class="text-red"
              ></default-display>
            </b-link>
          </template>
          <template
            slot="cell(pre_slab_booking_no)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pre_slab_booking_no')"
            >
              <default-display
                :value="item.pre_slab_booking_no"
                default-value="[Set]"
                default-class="text-red"
              ></default-display>
            </b-link>
          </template>
          <template
            slot="cell(pre_slab_inspection_passed)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pre_slab_inspection_passed'"
            >
              <boolean-display
                show-icon
                :value="item.pre_slab_inspection_passed"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(pre_slab_notes)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pre_slab_notes'"
            >
              <default-display :value="item.pre_slab_notes"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(pre_slab_passed)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pre_slab_passed'"
            >
              <date-display
                :value="item.pre_slab_passed"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(pump)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'pump')"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.pump"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </b-link>
          </template>
          <template slot="cell(pump_ohs)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'pump_ohs'"
            >
              <boolean-display
                show-icon
                :value="item.pump_ohs"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(purchase_order_number)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'purchase_order_number'"
            >
              <default-display
                :value="item.purchase_order_number"
              ></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(replaced_data)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'replaced_data'"
            >
              {{ item.replaced_data }}
            </o-link-cell>
          </template>
          <template slot="cell(rock_date)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'rock_date')"
            >
              <date-display
                :value="item.rock_date"
                :format="DAY_DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(rock_m2)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'rock_m2'"
            >
              <number-display :value="item.rock_m2" :decimals="2" />
            </o-link-cell>
          </template>
          <template slot="cell(set_out_date)" slot-scope="{ index, item }">
            <date-display
              :value="item.set_out_date"
              :format="DAY_DATE_FORMAT"
            ></date-display>
          </template>
          <template slot="cell(site_address)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_address'"
            >
              <default-display :value="item.site_address"></default-display>,
              <default-display :value="item.suburb"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(site_cut)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut'"
            >
              <boolean-display
                show-icon
                :value="item.site_cut"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(site_cut_crew)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_crew'"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.site_cut_crew"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(site_cut_date)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_date'"
            >
              <date-display
                :value="item.site_cut_date"
                :format="DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(site_cut_date_received)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_date_received'"
            >
              <date-display
                :value="item.site_cut_date_received"
                :format="DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <template slot="cell(site_cut_ohs)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_ohs'"
            >
              <boolean-display
                show-icon
                :value="item.site_cut_ohs"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(site_cut_percentage_done)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_percentage_done'"
            >
              <number-display
                :value="item.site_cut_percentage_done"
                :decimals="0"
              />
            </o-link-cell>
          </template>
          <template
            slot="cell(site_cut_retaining_walls)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_retaining_walls'"
            >
              <boolean-display
                show-icon
                :value="item.site_cut_retaining_walls"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(site_cut_spoil)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_spoil'"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.site_cut_spoil"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template slot="cell(site_cut_tipsite)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_tipsite'"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.site_cut_tipsite"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(site_cut_wanted_date)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'site_cut_wanted_date'"
            >
              <date-display
                :value="item.site_cut_wanted_date"
                :format="DATE_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </o-link-cell>
          </template>
          <!--template slot="cell(steel_booking_number)" slot-scope="{index, item}">
                <b-link class="editable"  v-on:click="showModal(index, item, 'steel_booking_number')">
                    <default-display :value="item.steel_booking_number" default-value="[Set]"></default-display>                </b-link>
            </template-->
          <template
            slot="cell(steel_inspection_date)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'steel_inspection_date')"
            >
              <date-display
                :value="item.steel_inspection_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'steel_inspection_passed')"
            >
              <boolean-display
                show-icon
                :value="item.steel_inspection_passed"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'steel_booking_number')"
            >
              <default-display
                :value="item.steel_booking_number"
                default-value="[Set]"
                default-class="text-red"
              ></default-display>
            </b-link>
          </template>
          <template
            slot="cell(steel_inspection_passed)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'steel_inspection_passed'"
            >
              <boolean-display
                show-icon
                :value="item.steel_inspection_passed"
              ></boolean-display>
            </o-link-cell>
          </template>
          <template slot="cell(steel_notes)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'steel_notes'"
            >
              <default-display :value="item.steel_notes"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(steel_ordered)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'steel_ordered')"
            >
              <boolean-display
                show-icon
                :value="item.steel_ordered"
              ></boolean-display>
            </b-link>
          </template>
          <template slot="cell(suburb)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'suburb'"
            >
              <default-display :value="item.suburb"></default-display>
            </o-link-cell>
          </template>
          <template slot="cell(supervisor)" slot-scope="{ index, item }">
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'supervisor'"
            >
              <lookup-display
                :list="optionSupervisorItemsById"
                :value="item.supervisor"
                display-field="name"
                default-value="-"
              ></lookup-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(termite_part_a_booking_no)"
            slot-scope="{ index, item }"
          >
            <o-link-cell
              :to="{ name: 'job.edit', params: { id: item.id } }"
              :when="first_column_key === 'termite_part_a_booking_no'"
            >
              <default-display
                :value="item.termite_part_a_booking_no"
              ></default-display>
            </o-link-cell>
          </template>
          <template
            slot="cell(termite_part_a_date)"
            slot-scope="{ index, item }"
          >
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'termite_part_a_date')"
            >
              <date-display
                :value="item.termite_part_a_date"
                :format="DATE_TIME_FORMAT"
                default-value="[Set]"
                default-class="text-red"
              ></date-display>
            </b-link>
          </template>
          <template slot="cell(wanted_pour_date)" slot-scope="{ index, item }">
            <date-display
              :value="item.wanted_pour_date"
              :format="DAY_DATE_FORMAT"
            ></date-display>
          </template>

          <template slot="cell(revisit_required)" slot-scope="{ index, item }">
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'revisit_required')"
            >
              <boolean-display
                show-icon
                :value="item.revisit_required"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
          </template>

          <template slot="cell(piers_excavator)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'piers_crew')"
            >
              <lookup-display
                :list="optionSupplierItemsById"
                :value="item.piers_crew"
                display-field="name"
                default-value="[Set]"
                default-class="text-red"
              ></lookup-display>
            </b-link>
            <br />
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'drilled')"
            >
              <boolean-display
                show-icon
                :value="item.drilled"
                default-value="[Set]"
                default-class="text-red"
              ></boolean-display>
            </b-link>
          </template>

          <template slot="cell(revisit_comment)" slot-scope="{ index, item }">
            <b-link
              class="editable"
              v-on:click="showModal(index, item, 'revisit_comment')"
            >
              <default-display
                :value="item.revisit_comment"
                default-value="[Set]"
                default-class="text-red"
              ></default-display>
            </b-link>
          </template>

          <template slot="empty">
            <p>
              <emoticon-sad-icon large></emoticon-sad-icon>
            </p>
            No Data Found. Please
            <router-link :to="{ name: 'job.create' }"
              >create a new item</router-link
            >
          </template>
        </b-table>
      </div>
    </template>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />

    <!-- modals -->
    <template>
      <div>
        <b-modal
          size="lg"
          ref="editmodal"
          @ok="updateValue"
          :title="modalTitle"
          :hide-footer="true"
        >
          <b-form @submit.stop.prevent="updateValue">
            <div class="d-block text-center" v-if="modalType">
              <o-select
                autofocus
                v-if="modalType.type === 'select'"
                nolabel
                :items="modalType.items"
                :sort-field="modalType.sortField"
                :text-field="modalType.textField"
                :value-field="modalType.valueField"
                v-model="modalValue"
                :form-state="formState"
                :loading="modalType.loading"
                name="crew_supplier"
                v-bind="modalSchemaField"
              >
              </o-select>

              <o-checkbox
                v-if="modalType.type === 'boolean'"
                v-model="modalValue"
                name="check"
                size="lg"
                v-bind="modalSchemaField"
                :form-state="formState"
              >
              </o-checkbox>

              <b-calendar
                v-model="modalValue"
                name="date"
                block
                locale="en-US"
                v-if="modalType.type === 'date'"
                v-bind="modalSchemaField"
              ></b-calendar>

              <date-time-picker
                v-if="modalType.type === 'datetime'"
                v-model="modalValue"
                name="date_and_time"
                v-bind="modalSchemaField"
              ></date-time-picker>

              <o-text-field
                @keydown.enter.prevent="updateValue()"
                v-if="modalType.type === 'number'"
                v-model="modalValue"
                nolabel
                step="1"
                type="number"
                name="numb"
                v-bind="modalSchemaField"
                autofocus
                :form-state="formState"
              ></o-text-field>
              <o-number-field
                @keydown.enter.prevent="updateValue()"
                v-if="modalType.type === 'decimal'"
                v-model="modalValue"
                :form-state="formState"
                name="piers_concrete_ordered"
                v-bind="modalSchemaField"
              ></o-number-field>
              <o-text-field
                @keydown.enter.prevent="updateValue()"
                v-if="modalType.type === 'input'"
                v-model="modalValue"
                nolabel
                autofocus
                name="in"
                v-bind="modalSchemaField"
                :form-state="formState"
              >
              </o-text-field>
              <o-textarea
                @keydown.enter.prevent="updateValue()"
                autofocus
                v-if="modalType.type === 'textarea'"
                v-model="modalValue"
                nolabel
                name="ta"
                v-bind="modalSchemaField"
                max-rows="8"
                :form-state="formState"
              >
              </o-textarea>
            </div>
            <br />
            <b-button type="submit" variant="primary">Submit</b-button>
            <b-button type="reset" variant="default" @click="resetValue"
              >Reset</b-button
            >
          </b-form>
        </b-modal>
      </div>
    </template>

    <div
      class="alert alert-warning fixed-bottom"
      role="alert"
      v-if="disconnected"
    >
      You are currently disconnected.
      <b-button variant="warning" class="float-right" @click="tryToConnect"
        >Retry now</b-button
      >
    </div>
  </div>
</template>
<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  UseRestModuleMixin,
} from "../../../vue-ocom/mixins";
import { default as SupplierTypeMixin } from "../../job/mixins/supplier_type_mixin";
import MultiLineDisplay from "@/vue-ocom/components/display/MultiLineDisplay";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "@/vue-ocom/schema/schema_utils";
import { cleanUpModel } from "@/vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import ONumberField from "../../../vue-ocom/components/forms/fields/ONumberField";

import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OMoneyField from "../../components/money_field/OMoneyField";

import FilterIcon from "vue-material-design-icons/Filter";

import * as active from "../../../vue-ocom/utils/active.js";
import moment from "moment";

import {
  BIcon,
  BIconArrowsFullscreen,
  BIconCalendar,
  BIconDash,
  BIconPlus,
  BIconSearch,
  BIconCheck,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { vueWindowSizeMixin } from "vue-window-size";
import DateTimePicker from "@/app/pour_schedule/components/DateTimePicker";
import _ from "lodash";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";

const Centrifuge = require("centrifuge");

function DEFAULT_OPTIONS(query) {
  return {
    customer: query.customer || null,
    job_location: query.job_location || null,
    currentPage: parseInt(query.currentPage || "1"),
    filter: query.filter || "active",
    sort: query.sort || "",
    order: query.order || "",
    q: query.q || "",
    searchField: query.searchField || "",
    ordering: query.ordering || "",
    limit: parseInt(query.limit || "50"),
    offset: parseInt(query.offset || "0"),
    emptyPourDateFilter: query.emptyPourDateFilter + "" == "true" || true,
    wantedPierDateFilter: moment(
      query.wantedPierDateFilter || moment().format("YYYY-MM-DD")
    ).format("YYYY-MM-DD"),
  };
}

export default {
  name: "PierScheduleScreen",
  components: {
    DateTimePicker,
    BIcon,
    BIconArrowsFullscreen,
    BIconCalendar,
    BIconDash,
    BIconPlus,
    BIconSearch,
    BIconCheck,
    OTextArea,
    OCheckbox,
    ODateTime,
    OListToolbar,
    FilterIcon,
    MultiLineDisplay,
    OMoneyField,
    ONumberField,
  },
  mixins: [
    CreateListPageMixin("PierSchedule", "job"),
    UseRestModuleMixin(["PierSchedule"]),
    CreateGroupPermissionMixin("Job") /* Use job permissions here */,
    CreateCodeTableFetchMixin([
      "CodeJobLocation",
      "CodeJobType",
      "Customer",
      "Supplier",
      "CodeSupplierType",
      "Employee",
      "Supervisor",
    ]),
    CrewSupplierMixin(),
    vueWindowSizeMixin,
    SupplierTypeMixin,
  ],
  data() {
    return {
      concrete_supplied_id: 12,
      schemaModel: cleanUpModel(schema.Job, {}) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.Job),

      list_options: DEFAULT_OPTIONS(this.$route.query),

      disconnected: true /* Is it disconnected from centrifugo? */,
      retryTime: 10000 /* retry timeout for centrifugo */,
      DATE_TIME_FORMAT: "ddd DD/MM/YY hh:mm A",
      DATE_FORMAT: "DD/MM/YYYY",
      DAY_DATE_FORMAT: "ddd DD/MM/YY",

      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        actual_pier_date: {
          label: "Actual Piers Date",
          thStyle: { width: "60px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_inspection_date: {
          label: "Pier Inspection Date",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_date: {
          label: "Wanted Piers Date",
          thStyle: { width: "60px", fontSize: "0.75em", paddingRight: 0 },
        },
        original_job_number: {
          label: "Job No",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        customer: {
          label: "Customer",
          thStyle: { width: "60px", fontSize: "0.75em", paddingRight: 0 },
        },
        supervisor: {
          label: "Supervisor",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        site_address: {
          label: "Site Address",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        suburb: {
          label: "SUBURB",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        date_call_up_received: {
          label: "Call Up Received",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        set_out_date: {
          label: "Set Out Date",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        drain_date: {
          label: "Drain Date",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        wanted_pour_date: {
          label: "Wanted Pour Date",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        no_of_piers: {
          label: "Piers",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        piers_crew: {
          label: "Piers Excavator",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_inspection_approved: {
          label: "Inspection",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_pump_supplier: {
          label: "Pump",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        piers_concrete_ordered: {
          label: "Concrete Ordered",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_concrete_notes: {
          label: "Concrete Notes",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_poured_by_supplier: {
          label: "Poured By",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_concrete_confirmed: {
          label: "Concrete Confirmed",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        pier_concrete_time: {
          label: "Concrete Time",
          thStyle: { width: "60px", fontSize: "0.75em", paddingRight: 0 },
        },
        piers_excavator: {
          label: "Piers Excavator",
          thStyle: { width: "44px", fontSize: "0.75em", paddingRight: 0 },
        },
        comments: {
          label: "COMMENT",
          thStyle: { fontSize: "0.75em", paddingRight: 0 },
        },
        // Date Inspection Passed
        // Revisit Required
        // Revisit Comment
      },

      fullscreen: true,

      modalItem: null /* The Item we are editing in the modal */,
      modalValue: null,
      modalFieldname: null /* The field being updated */,
      modalSchemaField: null /*Schema field for the Modal */,
      modalType: null /* Type data for the Modal */,
      cent_callback: null /* SEt to a Call back when token changes */,
    };
  },
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("AuthModule", ["logout"]),

    changewantedPierDateFilter(days) {
      var today = moment().startOf("day");

      if (
        this.list_options.wantedPierDateFilter !== undefined &&
        this.list_options.wantedPierDateFilter !== null
      ) {
        var date = new Date(
          moment(this.list_options.wantedPierDateFilter).format("YYYY-MM-DD")
        );
      } else {
        var date = new Date();
      }

      if (days === 3 || days === -3) {
        this.list_options.wantedPierDateFilter = moment(date)
          .add("days", days)
          .format("YYYY-MM-DD");
        this.refreshList();
      } else if (days === 0) {
        this.list_options.wantedPierDateFilter = today.format(
          "YYYY-MM-DD"
        );
        this.list_options.q = "";
        this.list_options.searchField = "";
        this.list_options.job_location = null;
        this.list_options.customer = null;
        this.refreshList();
      }
    },
    setFullScreen() {
      this.fullscreen = !this.fullscreen;
    },
    before_get_all(list_options) {
      /* Overwrite this to update the list_options before the data is changed
       * NOT: use _.cloneDeep(list_options) so the url is not changed
       * */
      var result = _.cloneDeep(list_options);
      return result;
    },
    refreshList() {
      if (this.list_options.wantedPierDateFilter !== null) {
        this.list_options.emptyPourDateFilter = false;
      }

      var options = {
        q: this.list_options.q || "",
        customer: this.list_options.customer,
        job_location: this.list_options.job_location,
        emptyPourDateFilter: this.list_options.emptyPourDateFilter,
        wantedPierDateFilter: moment(
          this.list_options.wantedPierDateFilter
        ).format("YYYY-MM-DD"),
        searchField: this.list_options.searchField,

        offset: parseInt(this.$route.query.offset || 0),
        limit: parseInt(this.$route.query.limit || 10),
      };

      this.update_table(options);
    },
    clearFilters() {
      this.list_options = DEFAULT_OPTIONS();
      this.refreshList();
    },
    tryToConnect() {
      if (this.isLoggedIn) {
        this.connect();
      }
      window.setTimeout(function () {
        if (this.disconnected) {
          this.retryTime = this.retryTime * 5;
          this.tryToConnect(); // Try again
        }
      }, this.retryTime); // Attempt Reconnect
    },
    connect() {
      const vm = this;
      if (this.isLoggedIn) {
        // Initialize
        var url = process.env.VUE_APP_CENT_API;

        if (url === "wss:///connection/websocket") {
          // ie production then build from URL
          var schema = "ws://";
          if (window.location.protocol === "https:") {
            schema = "wss://";
          }
          url = schema + location.host + "/connection/websocket";
        }

        var options = {
          onRefresh(context, cb) {
            vm.cent_callback = cb;
            vm.logout();
          },
        };

        var centrifuge = new Centrifuge(url, options);
        centrifuge.setToken(this.token);

        // On connect
        centrifuge.on("connect", function (ctx) {
          console.log("connected", ctx);
          vm.disconnected = false;
        });

        // On disconnect
        centrifuge.on("disconnect", function (ctx) {
          console.log("disconnected", ctx);
          if (!ctx.reconnect) {
            vm.tryToConnect();
          }
          vm.disconnected = true;
        });

        // Subscribe
        centrifuge.subscribe("jobs", function (ctx) {
          const data = ctx.data;
          console.log(data);

          const job = _.find(vm.items, { id: data["id"] });

          if (job) {
            for (var fieldName in data) {
              if (fieldName !== "id") {
                vm.$set(job, fieldName, data[fieldName]);
              }
            }
          }
        });
      }

      // Connect
      centrifuge.connect();
    },
    showModal(index, item, field_name) {
      this.modalValue = item[field_name];
      this.modalItem = item;
      this.modalFieldname = field_name;
      this.modalSchemaField = this.schema.fields[field_name]; // the field
      this.modalType = this.ModalMapping[field_name];

      this.$refs["editmodal"].show();
    },
    hideModal() {
      this.$refs["editmodal"].hide();
    },
    updateValue() {
      this.updateItem(this.modalFieldname);
    },
    resetValue() {
      if (this.modalType.type == "textarea" || this.modalType.type == "input") {
        this.modalValue = "";
      }
      if (this.modalType.type == "boolean") {
        this.modalValue = false;
      }
      if (
        this.modalType.type == "datetime" ||
        this.modalType.type == "date" ||
        this.modalType.type == "ospeedselect" ||
        this.modalType.type == "select" ||
        this.modalType.type == "number" ||
        this.modalType.type == "decimal"
      ) {
        this.modalValue = null;
      }
    },
    updateItem(field_name) {
      const vm = this;
      const data = {
        id: this.modalItem.id,
        [field_name]: this.modalValue,
        who: vm.currentUser.id,
      };

      this.patchPierScheduleItem(data)
        .then((response) => {
          console.log(response);

          // close modal
          vm.hideModal(field_name);
        })
        .catch((error) => {
          let msg = "Could not update Job details";
          this.showMessage({ message: msg, type: "danger", show: true });
          console.log(error);
        });
    },
    jobNumber(item) {
      if (item.original_job_number) return item.original_job_number;
      else return item.id;
    },
    row_class(item, type) {
      if (type === "row") {
        return this.cell_style(null, "", item);
      }
    },
    cell_style(value, key, item) {
      var now = moment();

      if (!active.is_item_active(item, now)) return "strikethrough";

      if (
        (key === "actual_pier_date" || key === "job_location") &&
        this.isWarrnambool(item.actual_pier_date, item.job_location)
      )
        return "warrnambool";
      if (
        (key === "no_of_piers" || key === "pier_date") &&
        this.isAttentionNumPiers(item.no_of_piers)
      )
        return "attentionNumPiers";
      if (
        key === "part_a_supplier" &&
        this.isAttentionTermite(item.part_a_required, item.termite_part_a_date)
      )
        return "attentionTermite";

      if (this.isToday(item.actual_pier_date)) return "today";
      else if (this.isTomorrow(item.actual_pier_date)) return "tomorrow";
      else if (this.iscurrentDatePlus2(item.actual_pier_date))
        return "daysPlus2";
      else if (this.iscurrentDatePlus3(item.actual_pier_date))
        return "daysPlus3";
    },
    isToday(dt) {
      var today = moment(new Date()).format("YYYY-MM-DD");

      return moment(new Date(dt)).format("YYYY-MM-DD") === today;
    },
    isTomorrow(dt) {
      var today = moment(new Date(dt)).format("YYYY-MM-DD");
      var tomorrow = moment(new Date()).add(1, "days").format("YYYY-MM-DD");

      return today === tomorrow;
    },
    iscurrentDatePlus2(dt) {
      var theDate = moment(new Date(dt)).format("YYYY-MM-DD");
      var currentDatePlus2 = moment(new Date())
        .add(2, "days")
        .format("YYYY-MM-DD");

      return theDate === currentDatePlus2;
    },
    iscurrentDatePlus3(dt) {
      var theDate = moment(new Date(dt)).format("YYYY-MM-DD");
      var currentDatePlus3 = moment(new Date())
        .add(3, "days")
        .format("YYYY-MM-DD");

      return theDate === currentDatePlus3;
    },
    isWarrnambool(dt, dl) {
      var theDate = moment(new Date(dt)).format("YYYY-MM-DD");
      var currentDatePlus3 = moment(new Date())
        .add(3, "days")
        .format("YYYY-MM-DD");

      return theDate > currentDatePlus3 && dl === 2;
    },
    isAttentionNumPiers(dt) {
      return dt > 0;
    },
    isAttentionTermite(dt, dl) {
      return dt === true && dl === null; //dt = part_a_required; dl = termite_part_a_date
    },
    addTdClass(entries) {
      entries.forEach(function (entry) {
        if (entry) {
          entry["tdClass"] = "cell_style";
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      token: "AuthModule/token",
      isLoggedIn: "AuthModule/isLoggedIn",
      currentUser: "AuthModule/currentUser",
    }),
    getSupplierConcreteOnly() {
      let concrete = this.optionSupplierItems.filter((item) => {
        return item.type == this.concrete_supplied_id;
      });
      return concrete;
    },
    ModalMapping() {
      return {
        plan_provided: {
          type: "boolean",
        },
        date_call_up_received: {
          type: "datetime",
        },
        pour_date: {
          type: "datetime",
        },
        set_out_date: {
          type: "datetime",
        },
        no_of_piers: {
          type: "number",
        },
        piers_crew: {
          type: "select",
          items: this.piersSupplierType, // TODO Filtered List!!
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        pier_date: {
          type: "datetime",
        },
        actual_pier_date: {
          type: "datetime",
        },
        pier_ohs: {
          type: "boolean",
        },
        pier_inspection_date: {
          type: "datetime",
        },
        pier_booking_no: {
          type: "input",
        },
        drain_date: {
          type: "datetime",
        },
        wanted_pour_date: {
          type: "datetime",
        },
        part_a_supplier: {
          type: "select",
          items: this.partASupplierType, // TODO Filtered List!!
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        termite_part_a_date: {
          type: "datetime",
        },
        bob_cat: {
          type: "select",
          items: this.bobcatSupplierType, // TODO Filtered List!!
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        bob_cat_date: {
          type: "datetime",
        },
        bob_cat_ohs: {
          type: "boolean",
        },
        pump: {
          type: "select",
          items: this.pumpSupplierType, //TODO Right LIst!!
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        rock_date: {
          type: "datetime",
        },
        pre_slab_booked_date: {
          type: "datetime",
        },
        pre_slab_inspection_passed: {
          type: "boolean",
        },
        revisit_required: {
          type: "boolean",
        },
        drilled: {
          type: "boolean",
        },
        pre_slab_booking_no: {
          type: "input",
        },
        steel_inspection_date: {
          type: "datetime",
        },
        steel_inspection_passed: {
          type: "boolean",
        },
        steel_booking_number: {
          type: "input",
        },
        steel_ordered: {
          type: "boolean",
        },
        concrete_order: {
          type: "datetime",
        },
        concrete_notes: {
          type: "textarea",
        },
        revisit_comment: {
          type: "textarea",
        },
        comments: {
          type: "textarea",
        },
        piers_concrete_ordered: {
          type: "decimal",
        },
        pier_concrete_notes: {
          type: "textarea",
        },
        pier_concrete_time: {
          type: "datetime",
        },
        pier_concrete_confirmed: {
          type: "boolean",
        },
        pier_inspection_approved: {
          type: "boolean",
        },
        pier_pump_supplier: {
          type: "select",
          items: this.pumpSupplierType,
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        pier_inspector_supplier: {
          type: "select",
          items: this.steelSupplierType,
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        pier_concrete_supplier: {
          type: "select",
          items: this.concreteSupplierType,
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        pier_poured_by_supplier: {
          type: "select",
          items: this.crewSupplierType, // TODO Filtered List!!
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
        crew_supplier: {
          type: "select",
          items: this.crewSupplierType, // TODO Filtered List!!
          sortField: "name",
          textField: "name",
          valueField: "id",
          loading: this.optionSupplierWorking,
        },
      };
    },
    modalTitle() {
      if (this.modalSchemaField) {
        return this.modalSchemaField.label;
      } else {
        return "";
      }
    },
    optionsCustomer() {
      var options = [{ value: null, text: "-- Customer Name --" }];

      this.optionCustomerItems.forEach(function (item) {
        options.push({ value: item.id, text: item.name });
      });
      return options;
    },
    optionsCodeJobLocation() {
      var options = [{ value: null, text: "-- All --" }];

      this.optionCodeJobLocationItems.forEach(function (item) {
        options.push({ value: item.id, text: item.description });
      });
      return options;
    },
    allocation_height() {
      return this.windowHeight - 230 + "px";
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "actual_pier_date",
        "original_job_number",
        "customer",
        "supervisor",
        "site_address",
        "date_call_up_received",
        "set_out_date",
        "drain_date",
        "pier_date",
        "no_of_piers",
        "piers_concrete_ordered",
        "pier_concrete_notes",
        "pier_pump_supplier",
        "pier_poured_by_supplier",
        "pier_inspection_approved",
        "pier_concrete_confirmed",
        "pier_concrete_time",
        "piers_excavator",
        "comments",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      this.addTdClass(this.filterTableColumns(this.schema, fields));

      return this.filterTableColumns(this.schema, fields);
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
    items_with_date_breaks() {
      if (this.items) {
        var items = this.items;

        // var last_pier_date = "";
        // for (var i = 0; i < items.length; i++) {
        //   if (items[i].pier_date) {
        //     var current_pier_date = items[i].pier_date.substring(0, 10);

        //     items[i]._showDetails = false; // ensure not set!

        //     if (current_pier_date != last_pier_date && i > 0) {
        //       items[i - 1]._showDetails = true; // Show details on this  one!
        //       items[i - 1]._previous_pier_date = items[i].pier_date; // Show the
        //     }
        //     last_pier_date = current_pier_date;
        //   }
        // }
        var last_actual_pier_date = "";
        for (var i = 0; i < items.length; i++) {
          if (items[i].actual_pier_date) {
            var current_actual_pier_date = items[i].actual_pier_date.substring(
              0,
              10
            );

            items[i]._showDetails = false; // ensure not set!

            if (current_actual_pier_date != last_actual_pier_date && i > 0) {
              items[i - 1]._showDetails = true; // Show details on this  one!
              items[i - 1]._previous_actual_pier_date =
                items[i].actual_pier_date; // Show the
            }
            last_actual_pier_date = current_actual_pier_date;
          }
        }
      }

      return this.items;
    },
  },
  watch: {
    token: function (newToken) {
      if (this.cent_callback != null) {
        this.cent_callback({ data: { token: newToken } });
      }
    },
  },
  created() {
    // Automatically connect to centrifugo
    this.tryToConnect();
  },
};
</script>

<style>
table td,
table th {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11.2px;
}
/* yellow #ffeb3b */
/* salmon #fa8072 */
.salmon {
  background-color: #fa8072;
}
td.salmon a {
  background-color: #fa8072;
}
.yellow {
  background-color: #ffeb3b;
}
td.yellow a {
  background-color: #ffeb3b;
}
.bright-green {
  background-color: #06b306;
}
td.bright-green a {
  background-color: #06b306;
}
.greyish-green {
  background-color: #656255;
  color: #fff;
}
td.greyish-green a {
  background-color: #656255;
  color: #fff;
}
a.a_blacked {
  color: black;
  text-decoration: underline;
}

tr.b-table-details,
tr.b-table-top-row {
  background: black;
  color: white;
}
tr.b-table-details > td,
tr.b-table-top-row > td {
  padding: 0px;
}

.daterow {
  width: 100%;
  text-align: left;
  display: block;
  padding-left: 1em;
}
a.editable {
  text-decoration: none;
  border-bottom: dashed 1px #428bca;
  color: black;
  font-weight: bold;
}
/* Light blue */
.today {
  background-color: #c1cdcd;
}

/* Light green */
.tomorrow {
  background-color: #c0ff97;
}

/* Light yellow */
.daysPlus2 {
  background-color: #edef85;
}

/* Light pink */
.daysPlus3 {
  background-color: #fbb;
}

/* Flesh */
.warrnambool {
  background-color: #fc9;
}

/* Orange */
.attentionTermite,
.attentionNumPiers {
  background-color: #ff7256;
}
</style>
